export const isApolloErrorGuard = (error) => {
    return !!(error === null || error === void 0 ? void 0 : error.graphQLErrors);
};
